(function () {
  const SWIPER_SELECTOR = ".fer-diamonds__swiper";
  const MOBILE_MQ = window.matchMedia("(max-width: 900px)");

  const SWIPER_OPTIONS = {
    wrapperClass: "fer-diamonds__images",
    slideClass: "fer-diamonds__image",
    slidesPerView: "auto",
    spaceBetween: 14,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,
    grabCursor: true,
  };

  function initSwiper(el) {
    if (el.swiper) return;
    new Swiper(el, SWIPER_OPTIONS);
  }

  function destroySwiper(el) {
    if (!el.swiper) return;
    el.swiper.destroy(true, true);
  }

  function bindSwiper(el) {
    const update = () => {
      if (MOBILE_MQ.matches) {
        initSwiper(el);
      } else {
        destroySwiper(el);
      }
    };

    update();

    if (el.dataset.ferDiamondsBound) return;
    el.dataset.ferDiamondsBound = "true";
    MOBILE_MQ.addEventListener("change", update);
  }

  function initDiamondsSwipers(root) {
    if (typeof Swiper === "undefined") return;

    const scope = root && root.querySelector ? root : document;
    scope.querySelectorAll(SWIPER_SELECTOR).forEach(bindSwiper);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initDiamondsSwipers());
  } else {
    initDiamondsSwipers();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initDiamondsSwipers(event.target);
  });
})();
